import { render } from "./index.vue?vue&type=template&id=2f2e2c96"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/split-button/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f2e2c96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f2e2c96', __exports__)) {
    api.reload('2f2e2c96', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2f2e2c96", () => {
    api.rerender('2f2e2c96', render)
  })

}


export default __exports__